import React, { Fragment } from 'react';

const ExampleCsv = (props) => {
  const { headers, rows } = props;

  const tableHeaders = (
    headers.map(header => (
      <th key={header}>
        {header}
      </th>
    ))
  );

  const tableRow = row => (
    row.map(columnData => (
      <td key={columnData}>
        {columnData}
      </td>
    ))
  );

  const tableData = (
    rows.map(row => (
      <tr key={row}>
        {tableRow(row)}
      </tr>
    ))
  );

  return (
    <Fragment>
      <h3>
        Example CSV
      </h3>

      <table className="results ui striped table">
        <thead>
          <tr>
            {tableHeaders}
          </tr>
        </thead>
        <tbody>
          {tableData}
        </tbody>
      </table>

    </Fragment>
  );
};

export default ExampleCsv;



// WEBPACK FOOTER //
// ./app/javascript/app/components/admin2/bulk_story_tagging/example_csv.jsx